export const STATUS_EVENT_NAME = 'statecourts-mus-upload-status-change';
export const MAX_MEDIA_FILES = 15;
export const MAX_MEDIA_FILE_SIZE_MB = 200;
export const MAX_MEDIA_FILE_SIZE_BYTES = MAX_MEDIA_FILE_SIZE_MB * 1024 * 1024;
export const MAX_TRANSCRIPT_FILE_SIZE_MB = 2;
export const MAX_TRANSCRIPT_FILE_SIZE_BYTES = MAX_TRANSCRIPT_FILE_SIZE_MB * 1024 * 1024;
export const FILE_SIZE_DISPLAY_DECIMAL_PLACES = 3;
export const MEDIA_EXTENSIONS = new Set(['mp4', 'mpg', 'wmv', 'flv', 'mov', 'mp3', 'wma', 'wav', 'mkv']);
export const AUDIO_EXTENSIONS = new Set(['mp3', 'wma', 'wav']);
export const MEDIA_ACCEPT = Array.from(new Set([...MEDIA_EXTENSIONS, ...AUDIO_EXTENSIONS])).map((extension) => `.${extension}`).join(',');
export const TRANSCRIPT_ACCEPT = '.pdf';
export const TRANSCRIPT_EXTENSIONS = new Set(['pdf']);
export const DELETE_DIALOG_MIN_VISIBLE_MS = 600;
export const DEFAULT_MAX_PARALLEL_PART_UPLOADS = 10;
export const PROCESSING_MAX_TIME_SECONDS = 600;
export const MULTIPART_MAX_RETRY_COUNT = 3;
export const MULTIPART_RETRY_DELAY_SECOND = 3;
export const MULTIPART_RETRY_DELAY_MS = MULTIPART_RETRY_DELAY_SECOND * 1000;
